/**
 * A2UI Icon Component
 * Displays Bootstrap Icons
 */

import React from 'react';

const A2UIIcon = ({ 
  name,
  size = 16,
  color,
  style,
  resolveValue,
  surfaceId
}) => {
  const resolvedName = resolveValue ? resolveValue(name, surfaceId) : name?.literalString || name || 'circle';
  
  const iconStyle = {
    fontSize: `${size}px`,
    color: color || 'currentColor',
    ...style
  };

  // Using Bootstrap Icons class naming convention
  return (
    <i 
      className={`bi bi-${resolvedName} a2ui-icon`}
      style={iconStyle}
    />
  );
};

export default A2UIIcon;
